import ReportingScreenContainer from './ReportingScreenContainer';
export default ReportingScreenContainer;
